module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("If anyone saith, “I love God,” and hates his brother, he is a liar; for he who does not love his brother whom he has seen, cannot love God whom he has not seen.")]), _vm._v(" — "), _c('b', [_vm._v("John 4:20 English Standard Version (ESV)")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('i', [_vm._v("So we beat on, boats against the current, borne back ceaselessly into the past.")]), _vm._v(" "), _c('b', [_vm._v("— F. Scott Fitzgerald, "), _c('i', [_vm._v("The Great Gatsby")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 72
// module chunks = 0